import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as menuCategoriesActions from '../../../redux/menuCategories/actions';
import * as menuItemsActions from '../../../redux/menuItems/actions';
import Spin from '../../../components/loading';
import '../styles.scss';
import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';
import ImageUploader from '../../../components/imageUploader';

class AddMenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      title: '',
      displayOrder: '',
      menuCategoryTitle: '',
      price: '',
      description: '',
      loaded: false,
      menuCategoryId: '',
      currency: '',
      meals: [],
      imageFileName: '',
      imageUrl: '',
      imageFileNameInputError: '',
      menuItemImages: [],
    };
  }

  componentDidMount() {
    // let query =`pageNumber=${controls.pageNumber}&pageSize=${controls.pageSize}`
    this.props.fetchAllMenuCategories();
    this.props.getMenuItemsImages();
    if (this.props.menuItemId) {
      this.props.fetchMenuItemById(this.props.menuItemId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.menuItemId &&
      prevState.loaded == false &&
      Object.entries(this.props.menuItemDetails).length
    ) {
      let {
        menuCategoryId,
        menuCategoryTitle,
        title,
        isActive,
        price,
        currency,
        displayOrder,
        description,
        meals,
        imageFileName,
        imageUrl,
      } = this.props.menuItemDetails;
      let mappedPortions = [];
      if (meals && meals.length) {
        mappedPortions = meals.map(x => ({
          value: x,
          label: enumHelper.convertEnumValueToTitle(
            ENUMS.MEAL_PORTIONS.list,
            x,
          ),
        }));
      }

      this.setState({
        menuCategoryId,
        menuCategoryTitle,
        title,
        isActive,
        price,
        currency,
        displayOrder,
        description,
        imageFileName,
        imageUrl,
        meals: mappedPortions,
        loaded: true,
      });
    }
  }

  saveNewMenuItem = () => {
    let {
      menuCategoryId,
      title,
      isActive,
      price,
      displayOrder,
      description,
      meals,
      imageFileName,
    } = this.state;
    let mealsValue = [];
    mealsValue = meals?.map(meal => meal.value);
    let menuItemObject = {
      title,
      displayOrder,
      menuCategoryId:
        typeof menuCategoryId == typeof 3
          ? menuCategoryId
          : menuCategoryId.value,
      isActive,
      price,
      description,
      meals: mealsValue.length !== 0 ? mealsValue : [],
      imageFileName,
    };

    if (!this.props.menuItemId) {
      this.props
        .insertNewMenuItem(menuItemObject)
        .then(() => this.props.closeModal());
    } else {
      menuItemObject.id = this.props.menuItemId;
      menuItemObject.imageFileName = this.state.imageFileName;
      // if(this.state.imageFileName === undefined){
      //   menuItemObject.imageFileName = this.state.imageUrl;
      // } else{
      //   menuItemObject.imageFileName = this.state.imageFileName;
      // }
      this.props.updateMenuItem(menuItemObject).then(() => {
        let {
          editMenuItemError,
          editMenuItemMessage,
          editMenuItemFailed,
        } = this.props;
        if (
          editMenuItemError == false &&
          editMenuItemMessage == null &&
          editMenuItemFailed == false
        ) {
          this.props.closeModal();
        }
      });
    }
  };

  changeMealPortions = meals => {
    this.setState({ meals });
  };

  onUploadAdImageSuccess = uploadedImage => {
    this.setState(() => ({
      imageFileName: uploadedImage.fileName,
      imageUrl: uploadedImage.url,
      imageFileNameInputError: '',
    }));
  };

  deleteAdImage = param => {
    this.setState(() => ({
      imageFileName: '',
      imageUrl: '',
      imageFileNameInputError: '',
    }));
  };

  onSelectItem = item => {
    this.setState(() => ({
      menuItemImages: item,
    }));
  };

  render() {
    let {
      menuCategoryId,
      title,
      isActive,
      menuCategoryTitle,
      price,
      displayOrder,
      description,
    } = this.state;

    let {
      error,
      loading,
      message,
      failed,
      menuCategoriesList,
      menuCategoryLoading,
      menuCategoryMessage,
      menuCategoryFailed,
      menuCategoryError,
      menuItemDetailsLoading,
      menuItemDetailsFailed,
      menuItemDetailsError,
      menuItemDetailsMessage,
      menuItemDetails,
      editMenuItemLoading,
      editMenuItemError,
      editMenuItemFailed,
      editMenuItemMessage,
    } = this.props;

    return (
      <>
        <Modal
          id='financial-transaction-modal'
          size='xl'
          isOpen={this.props.isOpen}
        >
          <ModalHeader>
            <div className='row'>
              <div className='col-11'>{locales('titles.newMenuItem')}</div>
              <div className='col-1 text-left'>
                <a
                  href='#'
                  className=''
                  onClick={event => {
                    event.preventDefault();
                    this.props.closeModal();
                  }}
                >
                  <i className='fas fa-times'></i>
                </a>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Spin
              spinning={
                loading ||
                menuCategoryLoading ||
                menuItemDetailsLoading ||
                editMenuItemLoading
              }
            >
              <article>
                {(error ||
                  menuCategoryError ||
                  menuItemDetailsError ||
                  editMenuItemError) && (
                  <div className='alert alert-danger'>
                    {locales('messages.server.error')}
                  </div>
                )}
                {(failed ||
                  menuCategoryFailed ||
                  menuItemDetailsFailed ||
                  editMenuItemFailed) && (
                  <div className='alert alert-danger'>
                    {message ||
                      menuCategoryMessage ||
                      menuItemDetailsMessage ||
                      editMenuItemMessage}
                  </div>
                )}
                <div className='col-12'>
                  <div className='d-flex col-12 flex-sm-column flex-md-row justify-content-between align-items-center mt-2'>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center required'>
                      <label
                        className='d-flex col-2 rsee-form-label'
                        htmlFor='title'
                      >
                        {locales('tables.title')}
                      </label>
                      <input
                        type='text'
                        id='title'
                        className='form-control col-10 '
                        placeholder={locales('tables.title')}
                        onChange={event =>
                          this.setState({ title: event.target.value })
                        }
                        value={title}
                      />
                    </div>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center required'>
                      <label
                        className='d-flex col-3 rsee-form-label'
                        htmlFor='menuCategoryId'
                      >
                        {locales('tables.category')}
                      </label>
                      <Select
                        placeholder={
                          menuCategoryTitle || locales('tables.category')
                        }
                        name='menuCategoryId'
                        className='col-10'
                        isMulti={false}
                        value={menuCategoryId}
                        options={menuCategoriesList.map(category => ({
                          label: category.title,
                          value: category.id,
                        }))}
                        onChange={menuCategoryId =>
                          this.setState({ menuCategoryId })
                        }
                      />
                    </div>
                  </div>

                  <div className='d-flex col-12 flex-sm-column flex-md-row justify-content-between align-items-center mt-2'>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center required'>
                      <label
                        className='rsee-form-label d-flex col-2'
                        htmlFor='price'
                      >
                        {locales('tables.price')}
                      </label>
                      <input
                        type='text'
                        id='price'
                        className='form-control col-10'
                        placeholder={locales('tables.price')}
                        onChange={event =>
                          this.setState({ price: event.target.value })
                        }
                        value={price}
                      />
                    </div>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center'>
                      <label
                        className='rsee-form-label d-flex col-3'
                        htmlFor='display'
                      >
                        {locales('tables.displayOrder')}
                      </label>
                      <input
                        type='text'
                        id='display'
                        className='form-control col-9'
                        placeholder={locales('tables.displayOrder')}
                        onChange={event =>
                          this.setState({ displayOrder: event.target.value })
                        }
                        value={displayOrder}
                      />
                    </div>
                  </div>

                  <div className='d-flex col-12 flex-sm-column flex-md-row justify-content-between align-items-center mt-2'>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center'>
                      <label
                        className='rsee-form-label d-flex InsertNewItemLabelWidth col-4'
                        htmlFor='title'
                      >
                        {locales('tables.dayMealPortion')}
                      </label>
                      <Select
                        id='meals'
                        name='meals'
                        className='rc-dropdown col-8'
                        placeholder={locales('messages.selectMealPortions')}
                        isMulti={true}
                        options={ENUMS.MEAL_PORTIONS.list.map(type => ({
                          label: type.title,
                          value: type.value,
                        }))}
                        onChange={this.changeMealPortions}
                        value={this.state.meals}
                      />
                    </div>
                    <div className='d-flex col-md-6 col-sm-12 justify-content-between align-items-center required'>
                      <label className='col-1 '>
                        {locales('tables.activated')}
                      </label>
                      <input
                        className='form-control col-8'
                        type='checkbox'
                        onChange={() => this.setState({ isActive: !isActive })}
                        checked={isActive}
                      />
                    </div>
                  </div>

                  <div className='d-flex col-12 flex-sm-column flex-md-row justify-content-between align-items-center mt-2'>
                    <div className='d-flex col-12 justify-content-start align-items-center required'>
                      <label
                        className='rsee-form-label d-flex col-1'
                        htmlFor='description'
                      >
                        {locales('messages.description')}
                      </label>
                      <textarea
                        type='text'
                        id='description'
                        className='form-control col-11'
                        placeholder={locales('messages.description')}
                        onChange={event =>
                          this.setState({ description: event.target.value })
                        }
                        value={description}
                      />
                    </div>
                  </div>

                  <div className='d-flex col-12 flex-sm-column flex-md-row justify-content-between align-items-center mt-2'>
                    <label className='rsee-form-label'>
                      {locales('menu.item.image')}
                    </label>
                    <div className='d-flex justify-content-start align-items-center required'>
                      <div className='full-width'>
                        <ImageUploader
                          placeholder={locales('menu.item.image')}
                          isMulti={false}
                          actionUrl={`${API_ENDPOINT}/v1/general/upload-cafe-menu-item-image`}
                          imageFile={this.state.imageUrl}
                          onUploadSuccess={this.onUploadAdImageSuccess}
                          deleteImage={this.deleteAdImage}
                        />
                        <div
                          className={`invalid-feedback ${
                            !!this.state.imageFileNameInputError
                              ? 'is-invalid-feedback'
                              : ''
                          }`}
                        >
                          {this.state.imageFileNameInputError}
                        </div>
                      </div>
                    </div>
                    <div className='w-3/4 align-self-start mr-2'>
                      <div className='d-flex flex-wrap'>
                        {this.props.menuItemImages?.map(item => (
                          <button
                            className='btn btn-outline-info btn-sm m-2 px-2 py-0'
                            onClick={() => this.onSelectItem(item)}
                          >
                            {item.title}
                          </button>
                        ))}
                      </div>
                      <div className='d-flex flex-wrap w-full'>
                        {this.props.menuItemImages.map(
                          item =>
                            this.state.menuItemImages.title === item.title &&
                            item.images.map(image => (
                              <img
                                src={image.imageUrl}
                                alt={item.title}
                                width='100'
                                height='100'
                                className={`m-2 border rounded ${this.state
                                  .imageFileName === image.imageFileName &&
                                  'border-4 border-info'}`}
                                onClick={() =>
                                  this.setState(() => ({
                                    imageFileName: image.imageFileName,
                                    imageUrl: image.imageUrl,
                                    imageFileNameInputError: '',
                                  }))
                                }
                              />
                            )),
                        )}
                      </div>
                    </div>
                  </div>
                  <small className='form-text text-muted'>
                    {locales('messages.select.ad.image.helper.text')}
                  </small>
                </div>
              </article>
            </Spin>
          </ModalBody>
          <ModalFooter>
            <button
              className='btn btn-success'
              onClick={() => this.saveNewMenuItem()}
            >
              {locales('labels.save')}
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.menuItemsReducer.insertNewMenuItemLoading,
    failed: state.menuItemsReducer.insertNewMenuItemFailed,
    error: state.menuItemsReducer.insertNewMenuItemError,
    message: state.menuItemsReducer.insertNewMenuItemMessage,

    menuCategoriesList: state.menuCategoriesReducer.menuCategoriesList,
    menuCategoryLoading: state.menuCategoriesReducer.menuCategoriesLoading,
    menuCategoryMessage: state.menuCategoriesReducer.menuCategoriesMessage,
    menuCategoryFailed: state.menuCategoriesReducer.menuCategoriesFailed,
    menuCategoryError: state.menuCategoriesReducer.menuCategoriesError,

    menuItemDetailsLoading: state.menuItemsReducer.menuItemDetailsLoading,
    menuItemDetailsFailed: state.menuItemsReducer.menuItemDetailsFailed,
    menuItemDetailsMessage: state.menuItemsReducer.menuItemDetailsMessage,
    menuItemDetailsError: state.menuItemsReducer.menuItemDetailsError,
    menuItemDetails: state.menuItemsReducer.menuItemDetails,

    editMenuItemLoading: state.menuItemsReducer.editMenuItemLoading,
    editMenuItemFailed: state.menuItemsReducer.editMenuItemFailed,
    editMenuItemMessage: state.menuItemsReducer.editMenuItemMessage,
    editMenuItemError: state.menuItemsReducer.editMenuItemError,
    editMenuItem: state.menuItemsReducer.editMenuItem,

    menuItemImages: state.menuItemsReducer.menuItemImages,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateMenuItem: menuItemObject =>
      dispatch(menuItemsActions.updateMenuItem(menuItemObject)),
    fetchMenuItemById: id => dispatch(menuItemsActions.fetchMenuItemById(id)),
    insertNewMenuItem: additionObject =>
      dispatch(menuItemsActions.insertNewMenuItem(additionObject)),
    fetchAllMenuCategories: () =>
      dispatch(menuCategoriesActions.fetchAllMenuCategories()),
    getMenuItemsImages: () => dispatch(menuItemsActions.getMenuItemsImages()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuItem);
